import styled from 'styled-components'
import { COLOURS } from 'resources'

export const LinkContainer = styled.a`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: ${COLOURS.primaryBlue};
  align-self: flex-start;
  transition: ease-in-out all 0.3s;

  &:hover {
    color: ${COLOURS.primaryBlue};
    text-decoration: none;
    opacity: 0.7;
  }
`

export const LinkText = styled.span`
  margin-left: 15px;
`
export const ArrowIcon = styled.img`
  width: 32px;
`
